import { seoMeta } from "@/lib/ui/seo";

export function ethosHead() {
    return seoMeta({
        title: "Our Ethos — Wags",
        description:
            "Ohana means family. Our vision is Ohana, for every pet and parent.",
        url: "/ethos",
    });
}

export function valuesHead() {
    return seoMeta({
        title: "Our Values — Wags",
        description:
            "Care as if they're yours. Dogs and underdogs. Velocity over speed.",
        url: "/values",
    });
}

export function faqHead() {
    return seoMeta({
        title: "Frequently asked questions | Wags",
        description:
            "Answers to common questions about finding a pet with Wags.",
        url: "/faq",
    });
}

export function ariSampleHead() {
    return seoMeta({
        title: "Kinako Hill Shibas is a pretend breeder | Wags",
        description:
            "Kinako Hill Shibas is a made-up breeder we use to show how Ari works. Text Ari to claim your real Wags page.",
        url: "/kinako-hill-shibas",
        image: "https://www.wags.com/og-ari.jpg",
        noindex: true,
    });
}
